import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class UrlService {

    currentUrl = '';
    navigationSubj = new BehaviorSubject<string>(null);

    constructor(public router: Router) {
        router.events.subscribe((navigation: any) => {
            if (navigation instanceof NavigationEnd) {
                this.currentUrl = navigation.url;
                this.navigationSubj.next(this.currentUrl);
            }
        });
    }

}
